import type { z } from 'zod';
import type { crimeSchema } from '../schema.ts';

/** Petty crimes, cheapest Nerve first. Numbers are starting defaults for the simulator to tune. */
export const crimes: z.input<typeof crimeSchema>[] = [
  {
    key: 'beg', name: 'Beg on the church steps', icon: 'open-palm', nerve: 1,
    description: 'Rattle a cup at the pious.',
    successChance: 0.9, catchChance: 0.1, coin: { min: 1, max: 4 }, gaolMinutes: 3,
    success: 'A goodwife drops a few coppers in your cup.',
    failure: 'The faithful look straight through you.',
    caught: 'The beadle drags you off for vagrancy.',
  },
  {
    key: 'pick-pocket', name: 'Pick a pocket', icon: 'assassin-pocket', nerve: 2,
    description: 'A purse-string, a crowd and a light touch.',
    successChance: 0.7, catchChance: 0.4, coin: { min: 5, max: 20 }, gaolMinutes: 6,
    success: 'A fat purse comes away in your hand.',
    failure: 'Your mark turns at the last moment. You melt into the crowd.',
    caught: '“Thief!” A watchman’s hand closes on your collar.',
  },
  {
    key: 'filch-stall', name: 'Filch from a stall', icon: 'swap-bag', nerve: 3,
    description: 'Wait for the stallholder to look away.',
    successChance: 0.6, catchChance: 0.5, coin: { min: 8, max: 20 }, gaolMinutes: 10,
    mishap: { chance: 0.3, life: 15, infirmaryMinutes: 8, text: 'The stallholder’s dog has you by the leg before you clear the square.' },
    success: 'You slip away with a fistful of goods to sell on.',
    failure: 'The stallholder never takes their eyes off you.',
    caught: 'The stallholder bellows for the watch, and they come running.',
  },
  {
    key: 'poach-hare', name: 'Poach a hare', icon: 'rabbit', nerve: 4, poaching: true, towns: ['thornwood'],
    description: 'Snares in the king’s chase. The wardens hang poachers. Mostly.',
    successChance: 0.6, catchChance: 0.6, coin: { min: 10, max: 30 }, gaolMinutes: 15,
    success: 'A plump hare, sold out of the back door of an inn.',
    failure: 'Your snares come up empty.',
    caught: 'A verderer steps out from behind an oak, crossbow levelled.',
  },
  {
    key: 'burgle', name: 'Burgle a merchant’s house', icon: 'domino-mask', nerve: 5,
    description: 'Up the drainpipe, through the shutters, out before the dogs wake.',
    successChance: 0.5, catchChance: 0.5, coin: { min: 20, max: 50 }, gaolMinutes: 25,
    mishap: { chance: 0.4, life: 40, infirmaryMinutes: 15, text: 'A roof tile gives way and you fall two storeys into the yard.' },
    success: 'Silver plate and a strongbox. A good night’s work.',
    failure: 'The shutters are barred. You climb down empty-handed.',
    caught: 'You climb down straight into the arms of the night watch.',
  },
];
